
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface HeroSectionProps {
  onGetStarted: () => void;
}

export const HeroSection = ({ onGetStarted }: HeroSectionProps) => {
  return (
    <section className="pt-32 pb-16 md:pt-40 md:pb-24">
      <div className="container mx-auto px-4 text-center">
        <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary">
          Transform Your YouTube Experience with AI
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-4">
          Convert passive watching into active learning. Get instant insights and engage in meaningful conversations with any YouTube video.
        </p>
        <p className="text-base md:text-lg text-muted-foreground/80 max-w-xl mx-auto mb-8">
          Start your free 3-day trial today and experience the future of video learning.
        </p>
        <Button 
          size="lg" 
          className="animate-fade-in hover:scale-105 transition-transform duration-300 min-h-[48px]" 
          onClick={onGetStarted}
        >
          Start Your Free Trial <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </section>
  );
};
